import { mapGetters, mapState } from 'vuex'
import featuresByPlan from './featuresByPlan'
import featuresByPlanForTestGroup from './featuresByPlan.testgroup'
import { SLIDE_TYPE_LIMIT_TWO, SLIDES_TYPE_LIMIT_FIVE } from '@/constant/slideTypes'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      plan: (state) => state.currentUser.plan,
    }),
    ...mapGetters(['isTestNewFreePlan']),
    featuresByPlan() {
      if (this.isTestNewFreePlan) {
        return featuresByPlanForTestGroup
      }
      return featuresByPlan
    },
  },
  methods: {

    isForPairPlan(typeObj) {
      if (this.isTestNewFreePlan && this.plan === 'free') {
        if (typeObj.isForPairPlan) {
          return true
        }
        const { slides } = this.presentation
        const countPickerAnswer = slides.filter((item) => SLIDES_TYPE_LIMIT_FIVE.includes(item.type)).length
        const countLimitTwo = slides.filter((item) => SLIDE_TYPE_LIMIT_TWO.includes(item.type)).length
        if (SLIDES_TYPE_LIMIT_FIVE.includes(typeObj.type) && countPickerAnswer >= 5) {
          return true
        }
        if (SLIDE_TYPE_LIMIT_TWO.includes(typeObj.type) && countLimitTwo >= 2) {
          return true
        }
      }

      return false
    },
  },
}
